import ServicesGrid from '@/components/marketing/ServicesGrid';
import CtaBanner from '@/components/marketing/CtaBanner';
import EditorialMarquee from '@/components/marketing/EditorialMarquee';
import PageHeader from '@/components/layout/PageHeader';

export default function ServicesPage() {
  return (
    <>
      <PageHeader
        chapter="Chapter 002"
        eyebrow="Capabilities"
        title={<>Every trade,<br />under one roof.</>}
        blurb="Design-build workflows, in-house project management, and a bench of trusted specialists. One phone number, one plan, one crew."
      />
      <ServicesGrid />
      <EditorialMarquee />
      <CtaBanner place="services-page" />
    </>
  );
}
